import { render } from "./SideNav.vue?vue&type=template&id=b7adb064&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=b7adb064&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7adb064"],['__file',"src/common/components/SideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7adb064"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7adb064', __exports__)) {
    api.reload('b7adb064', __exports__)
  }
  
  module.hot.accept("./SideNav.vue?vue&type=template&id=b7adb064&scoped=true", () => {
    api.rerender('b7adb064', render)
  })

}


export default __exports__